import { ReactNode } from 'react';

import { LoaderFunction } from 'react-router-dom';

import CatalogueLayout from '~/pages/CatalogueLayout';
import CataloguePage from '~/pages/CataloguePage';

export enum RoutePath {
  DEFAULT = '*',
  HOME = '/',
}

export type RoutePathKey = keyof typeof RoutePath;
export type AppRoute = {
  path: string;
  index?: boolean;
  element?: ReactNode | null;
  protected?: boolean;
  children?: AppRoute[];
  loader?: LoaderFunction<unknown>;
};

export const ROUTES: AppRoute[] = [
  {
    path: RoutePath.HOME,
    element: <CatalogueLayout />,
    children: [
      {
        path: RoutePath.HOME,
        index: true,
        element: <CataloguePage />,
        protected: true,
      },
    ],
  },
];
